export const PERMISSIONS = {
  Add_Permission: [
    {
      id: 375,
      name: "Add Fingerprint Device",
      codename: "add_fingerprint_device",
    },
    {
      id: 376,
      name: "Add / Update Locations",
      codename: "add_locations",
    },
    {
      id: 377,
      name: "Add Public Holiday",
      codename: "add_public_holiday",
    },
    {
      id: 378,
      name: "Add Roles & Permission Template",
      codename: "add_roles_permission_template",
    },
  ],
  Allocate_Permission: [
    {
      id: 350,
      name: "Allocate Staff Overtime",
      codename: "allocate_staff_overtime",
    },
  ],
  Approve_Permission: [
    {
      id: 364,
      name: "Approve / Reject Requests",
      codename: "approve_reject_requests",
    },
  ],
  Assign_Permission: [
    {
      id: 370,
      name: "Assign Based Shift",
      codename: "assign_based_shift",
    },
    {
      id: 369,
      name: "Assign Fixed Shift",
      codename: "assign_fixed_shift",
    },
    {
      id: 371,
      name: "Assign Flexible Shift",
      codename: "assign_flexible_shift",
    },
    {
      id: 425,
      name: "Assign Punches",
      codename: "assign_punches",
    },
    {
      id: 368,
      name: "Assign Roles & Permission",
      codename: "assign_roles_permission",
    },
    {
      id: 426,
      name: "Recalculate Shifts",
      codename: "recalculate_shifts",
    },
    {
      id: 427,
      name: "Recalculate All Staff (org-wide)",
      codename: "recalculate_all_staff",
    },
  ],
  Create_Permission: [
    {
      id: 353,
      name: "Create and Update Fixed Shift Templete",
      codename: "create_and_update_fixed_shift_templete",
    },
    {
      id: 354,
      name: "Create and Update Working Hour",
      codename: "create_and_update_working_hour",
    },
    {
      id: 357,
      name: "Create Bulk Upload",
      codename: "create_bulk_upload",
    },
    {
      id: 363,
      name: "Create Leave Balance Bulk Upload",
      codename: "create_leave_balance_bulk_upload",
    },
    {
      id: 352,
      name: "Create Organization Hierarchy",
      codename: "create_organization_hierarchy",
    },
    {
      id: 351,
      name: "Create Requests",
      codename: "create_requests",
    },
    {
      id: 362,
      name: "Create/Update Balance",
      codename: "create_update_balance",
    },
    {
      id: 361,
      name: "Create/Update CFM Staff",
      codename: "create_update_cfm_staff",
    },
    {
      id: 359,
      name: "Create / Update Departments",
      codename: "create_update_departments",
    },
    {
      id: 360,
      name: "Create / Update Projects",
      codename: "create_update_project_categories",
    },
    {
      id: 358,
      name: "Create / Update Zones",
      codename: "create_update_zones",
    },
    {
      id: 355,
      name: "Update My Staff Shift",
      codename: "update_my_staff_shift",
    },
    {
      id: 356,
      name: "Update Public Holiday",
      codename: "update_public_holiday",
    },
  ],
  Delegate_Permission: [
    {
      id: 366,
      name: "Create/Update Delegate User",
      codename: "create_update_delegate_user",
    },
    {
      id: 365,
      name: "Delegate Requests",
      codename: "delegate_requests",
    },
    {
      id: 367,
      name: "Delete Delegate User",
      codename: "delete_delegate_user",
    },
  ],
  Delete_Permission: [
    {
      id: 383,
      name: "Allowed To Cancel Request",
      codename: "allowed_to_cancel_request",
    },
    {
      id: 384,
      name: "Delete CFM Staff",
      codename: "delete_cfm_staff",
    },
    {
      id: 389,
      name: "Delete Departments",
      codename: "delete_departments",
    },
    {
      id: 386,
      name: "Delete Fingerprint Device",
      codename: "delete_fingerprint_device",
    },
    {
      id: 391,
      name: "Delete Fixed Shift",
      codename: "delete_fixed_shift",
    },
    {
      id: 387,
      name: "Delete Locations",
      codename: "delete_locations",
    },
    {
      id: 393,
      name: "Delete My Staff Shift",
      codename: "delete_my_staff_shift",
    },
    {
      id: 395,
      name: "Delete Overtime",
      codename: "delete_overtime",
    },
    {
      id: 385,
      name: "Delete Project",
      codename: "delete_project",
    },
    {
      id: 390,
      name: "Delete Project Categories",
      codename: "delete_project_categories",
    },
    {
      id: 394,
      name: "Delete Public Holiday",
      codename: "delete_public_holiday",
    },
    {
      id: 428,
      name: "Delete Shifts",
      codename: "delete_shifts",
    },
    {
      id: 392,
      name: "Delete Working Hour",
      codename: "delete_working_hour",
    },
    {
      id: 388,
      name: "Delete Zones",
      codename: "delete_zones",
    },
  ],
  Setup_Permission: [
    {
      id: 382,
      name: "Balance Permission",
      codename: "balance_permission",
    },
    {
      id: 381,
      name: "Request Policy Setup",
      codename: "request_policy_setup",
    },
    {
      id: 380,
      name: "Request Type Setup",
      codename: "request_type_setup",
    },
    {
      id: 379,
      name: "Workflow Setup",
      codename: "workflow_setup",
    },
  ],
  Shift_Permission: [
    {
      id: 374,
      name: "My Shifts Permission",
      codename: "my_shifts_permission",
    },
    {
      id: 372,
      name: "Shift Bulk Upload",
      codename: "shift_bulk_upload",
    },
    {
      id: 373,
      name: "Staff Shifts Permission",
      codename: "staff_shifts_permission",
    },
  ],
  View_Permission: [
    {
      id: 341,
      name: "View Activity",
      codename: "view_activity",
    },
    {
      id: 345,
      name: "View Balance",
      codename: "view_balance",
    },
    {
      id: 333,
      name: "View Calendar",
      codename: "view_calendar",
    },
    {
      id: 331,
      name: "View Dashboard",
      codename: "view_dashboard",
    },
    {
      id: 342,
      name: "View Export",
      codename: "view_export",
    },
    {
      id: 346,
      name: "View Filtered Check-in",
      codename: "view_filtered_checkin",
    },
    {
      id: 347,
      name: "View Filtered Conflict",
      codename: "view_filtered_conflict",
    },
    {
      id: 349,
      name: "View Leave Balance Bulk Upload Log",
      codename: "view_leave_balance_bulk_upload_log",
    },
    {
      id: 348,
      name: "View Missing Time",
      codename: "view_missing_time",
    },
    {
      id: 340,
      name: "View Notifications",
      codename: "view_notifications",
    },
    {
      id: 424,
      name: "View Punches",
      codename: "view_punches",
    },
    {
      id: 332,
      name: "View Reports",
      codename: "view_reports",
    },
    {
      id: 337,
      name: "View Requests",
      codename: "view_requests",
    },
    {
      id: 338,
      name: "View Shift Assignment",
      codename: "view_shift_assignment",
    },
    {
      id: 339,
      name: "View Shift Bulk Upload Log",
      codename: "view_shift_bulk_upload_log",
    },
    {
      id: 334,
      name: "View Staff Attendance",
      codename: "view_staff_attendance",
    },
    {
      id: 330,
      name: "View Staff Directory",
      codename: "view_staff_directory",
    },
    {
      id: 335,
      name: "View Staff Leave Balance",
      codename: "view_staff_leave_balance",
    },
    {
      id: 336,
      name: "View Staff Overtime",
      codename: "view_staff_overtime",
    },
    {
      id: 343,
      name: "View Statistics",
      codename: "view_statistics",
    },
    {
      id: 344,
      name: "View Uploads Logs",
      codename: "view_uploads_logs",
    },
  ],
} as const;

export type PermissionCodename =
  (typeof PERMISSIONS)[keyof typeof PERMISSIONS][number]["codename"];
